/** 卡片名称与稳定标识分层展示；标识只用于辨认，不取代业务 ID。 */
export default function SkillCardTitle({ name, identifier }: { name: string; identifier: string }) {
  const showIdentifier = /^[\x20-\x7e]+$/.test(identifier) && /[a-z]/i.test(identifier)
    && identifier.toLowerCase() !== name.toLowerCase();
  return <span className="flex min-w-0 flex-col">
    <span className="truncate text-[13px] font-semibold text-claude-text dark:text-claude-darkText" title={name}>{name}</span>
    {showIdentifier && <span className="truncate text-[11px] text-claude-textSecondary dark:text-claude-darkTextSecondary" title={identifier}>{identifier}</span>}
  </span>;
}
